import React, { useState } from "react";
import MainContent from "./MainContent";
import PricingPage from "./PricingPage";
import TopBar from "./TopBar";
import FeedbackModal from "./FeedbackModal";
import Footer from "./Footer";
import GrowYourBusiness from "./GrowYourBusiness";
import MasterInstagramSelling from "./MasterInstagramSelling";
import AIMoodAwareFeature from "./AIMoodAwareFeature";
import WhatOurUsersSay from "./WhatOurUsersSay";
import VideoJourneySteps from "./VideoJourneySteps";
import FAQSection from "./FAQSection";

import LandingRevamp from "./revamp/LandingRevamp";

const LandingPage = ({ onAuthSuccess }) => {
  const [feedbackOpen, setFeedbackOpen] = useState(false);
  const supportEmail =
    process.env.REACT_APP_SUPPORT_EMAIL || "noreply.reeltale@gmail.com";
  return (
    <div className="LandingPage min-h-screen flex flex-col bg-white dark:bg-gray-900 transition-colors duration-300">
      {/* Top Bar */}
      <TopBar onAuthSuccess={onAuthSuccess} />
      
      {/* New Revamped Home Screen */}
      <LandingRevamp setFeedbackOpen={setFeedbackOpen} />

      {/* Old Sections (Hidden for Revamp)
      <MainContent />
      <GrowYourBusiness />
      <MasterInstagramSelling />
      <AIMoodAwareFeature />
      <WhatOurUsersSay />
      <VideoJourneySteps />
      <PricingPage />
      <FAQSection />
      */}

      {/* Feedback Modal */}
      <FeedbackModal
        open={feedbackOpen}
        onClose={() => setFeedbackOpen(false)}
      />
    </div>
  );
};

export default LandingPage;
